// @generated by protoc-gen-connect-query v2.1.1 with parameter "target=ts"
// @generated from file provider/v1/provider.proto (package provider.v1, edition 2023)
/* eslint-disable */

import { Service } from "./provider_pb";

/**
 * @generated from rpc provider.v1.Service.FindProviders
 */
export const findProviders = Service.method.findProviders;

/**
 * @generated from rpc provider.v1.Service.GetRadius
 */
export const getRadius = Service.method.getRadius;

/**
 * @generated from rpc provider.v1.Service.GetCoverage
 */
export const getCoverage = Service.method.getCoverage;

/**
 * @generated from rpc provider.v1.Service.GetNetworkStatus
 */
export const getNetworkStatus = Service.method.getNetworkStatus;
